import React, { Component } from "react";
import { HelmetProvider } from "react-helmet-async";
import TodoApp from "./components/todo/TodoApp";
import "./App.css";
import "./bootstrap.css";
// theme.css must load after bootstrap.css so its color/typography overrides
// win cascade ties against Bootstrap's equal-specificity selectors
// (body, .card, .btn, etc.) — see src/theme.css's file header.
import "./theme.css";

class App extends Component {
  render() {
    return (
      <HelmetProvider>
        <div className="App">
          <TodoApp />
        </div>
      </HelmetProvider>
    );
  }
}

export default App;
